import { cn } from "@/lib/utils";

export function ClearIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[11px] text-white", className)}
      viewBox="0 0 11 11"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.39 5.569a.097.097 0 010-.137l3.583-3.584a.58.58 0 00-.821-.82L5.568 4.61a.097.097 0 01-.137 0L1.848 1.028a.58.58 0 10-.82.82L4.61 5.432a.097.097 0 010 .137L1.027 9.152a.58.58 0 00.821.821L5.431 6.39a.097.097 0 01.137 0l3.584 3.584a.58.58 0 10.82-.82L6.39 5.568z"
        fill="currentColor"
      />
    </svg>
  );
}

export function UploadIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[29px] w-[31px]", className)}
      fill="none"
      viewBox="0 0 31 29"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        fill="#a39fbc"
        height="22.404"
        rx="3"
        transform="matrix(.98551 .1696 -.17778 .98407 6.37 .824)"
        width="22.921"
      />
      <rect
        fill="#fff"
        height="22.388"
        rx="3"
        width="22.938"
        x="2.385"
        y="4.836"
      />
      <path
        d="M15.483 15.565L9.24 22.273h12.53a.3.3 0 00.22-.504l-5.774-6.204a.5.5 0 00-.732 0z"
        fill="#b331aa"
      />
      <path
        d="M9.304 18.105l-3.556 3.659a.3.3 0 00.215.509h8.109l-4.051-4.168a.5.5 0 00-.717 0z"
        fill="#b331aa"
      />
      <ellipse cx="10.978" cy="11.688" fill="#b331aa" rx="1.72" ry="1.679" />
    </svg>
  );
}
